import { PublicLayout } from "../components/PanelLayout";
import { Card } from "../components/ui";

export function NotFound() {
  return (
    <PublicLayout>
      <Card>
        <h1>Página não encontrada</h1>
        <p className="muted" style={{ marginTop: 12 }}>
          Confira o endereço. Se você recebeu um link por e-mail ou WhatsApp, abra direto pela
          mensagem.
        </p>
      </Card>
    </PublicLayout>
  );
}
